import script from "./PMPStep5Resumen.vue?vue&type=script&setup=true&lang=js"
export * from "./PMPStep5Resumen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__